import EventBus from "@plugins/common/service/eventbus";
export const GoogleAuthEventBus = new EventBus();
